import { assign } from 'lodash';
import { createReducer } from '../util';
import { UPDATE_CURRENT_ARTICLE } from './action';
import { State } from './type';

const initialState = { currentArticle: {} };

export default createReducer(initialState, {
  [UPDATE_CURRENT_ARTICLE]: function (
    state: State,
    action: { payload: unknown },
  ) {
    return assign({}, state, { currentArticle: action.payload });
  },
});
